import request from '@/utils/request'
import { AxiosPromise } from 'axios'
export function getSetting(): AxiosPromise {
    // 免登录配置（NotVerifies）。旧路径 /api/config/other_setting 需登录，坏/无 token 会直接 202
    return request({
        url: `/api/app/config/other_setting`,
        method: 'get',
    })
}
export function getOssSignatureInfo(): AxiosPromise {
    return request({
        url: `/hd-api/os/resources/aliyun/oss/signature`,
        method: 'get',
    })
}

// 钉钉JsApi鉴权
export function getDingSignatureInfo(data): AxiosPromise {
    return request({
        url: `/hd-api/os/login/dingtalk/js-api`,
        method: 'post',
        data:data
    })
}